// extracted by mini-css-extract-plugin
export default {"separator":"TimetableSeparator_separator__Btx63"};